import React from "react";
import { Controls, ControlButton } from "reactflow";

import { useAutoLayoutContext } from "../../contexts/AutoLayoutProvider";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";

const CustomControls = (props) => {
  const { autoLayout, autoLayoutOn, setAutoLayoutOn } = useAutoLayoutContext();

  const handleClick = () => {
    setAutoLayoutOn(!autoLayoutOn);
    if (!autoLayoutOn) autoLayout();
  };

  return (
    <Controls
      {...props}
      showInteractive={false}
      style={{ transform: "scale(1.1) translateY(-3px)" }}
    >
      <ControlButton onClick={handleClick} title="Auto Layout">
        <FontAwesomeIcon
          style={{
            transform: "scale(1.05)",
            color: autoLayoutOn ? "inherit" : "lightgray",
            transition: "color .25s ease",
          }}
          icon={faArrowsRotate}
        />
      </ControlButton>
    </Controls>
  );
};

export default CustomControls;
